import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import PersonRepository from '@/shared/http/repositories/configuration/person'
import StateRepository from '@/shared/http/repositories/geo/state'
import CityRepository from '@/shared/http/repositories/geo/city'
import InsuredModel from '@/shared/models/configuration/insuredmodel'
import InsuredForms from './insured-form'

export default {
  name: 'insured',
  mixins: [ActionsForm],
  data () {
    return {
      data: InsuredModel,
      form: InsuredForms
    }
  },
  components: {
    Cfg
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      this.form.stateID.value = obj.state.id
      // --> Set manual
      this.onChangeState()
      this.polling = setInterval(() => {
        this.setCityEdit(obj.cityID)
      }, 500)
      loading.pop()
    },
    onLoad () {
      loading.push()
      this.onLoadAllState()
      PersonRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      PersonRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      PersonRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      PersonRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllState () {
      loading.push()
      StateRepository.GetAll()
        .then((response) => {
          this.form.stateID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllCity (id) {
      this.form.cityID.options = []
      if (id) {
        loading.push()
        CityRepository.GetAllByStateID(id)
          .then((response) => {
            this.form.cityID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeState () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllCity(self.form.stateID.value)
      }, 500)
    },
    setCityEdit (cityID) {
      if (cityID) {
        var options = this.form.cityID.options
        if (options.length > 0) {
          clearInterval(this.polling)
          this.form.cityID.value = cityID
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/insured/insured.js